import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 資産状態 */
enum AssetStatus {
  normal = 'NORMAL',
  retired = 'RETIRED',
}

const nameConfig = {
  normal: new Map([
    [Locale.ja, '通常'],
    [Locale.en, 'Normal'],
  ]),
  retired: new Map([
    [Locale.ja, '除却済'],
    [Locale.en, 'Retired'],
  ]),
};

const toEnum = rawValueToEnum(AssetStatus, AssetStatus.normal);
const toDisplay = enumToName(AssetStatus, nameConfig);
const toDisplayWithPrefix = enumToName(AssetStatus, nameConfig, { prefix: true });

export const assetStatus = {
  enum: AssetStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AssetStatus };
